// Dynamically load Forte scripts from URLs specified in environment variables
export function loadForteScripts() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.__FORTE_LOADING__) return window.__FORTE_LOADING__;
  if (window.forte) {
    console.log('[ForteScriptLoader] Forte already loaded, skipping.');
    return Promise.resolve();
  }

  const checkoutSrc = process.env.REACT_APP_FORTE_CHECKOUT_URL;
  const apiSrc = process.env.REACT_APP_FORTE_API_URL;

  if (!checkoutSrc || !apiSrc) {
    console.error('[ForteScriptLoader] Missing Forte URLs in environment variables!');
    console.error('  REACT_APP_FORTE_CHECKOUT_URL:', checkoutSrc);
    console.error('  REACT_APP_FORTE_API_URL:', apiSrc);
    return Promise.reject(new Error('Forte URLs not configured'));
  }

  console.log('[ForteScriptLoader] Loading Forte scripts:');
  console.log('  Checkout URL:', checkoutSrc);
  console.log('  API URL:', apiSrc);

  function addScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) return resolve();
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;
      s.onload = () => resolve();
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });
  }

  window.__FORTE_LOADING__ = Promise.resolve()
    .then(() => addScript(checkoutSrc))
    .then(() => addScript(apiSrc))
    .catch((e) => {
      console.error('[ForteScriptLoader] Failed to load Forte scripts', { error: e });
    });

  return window.__FORTE_LOADING__;
}

// Simplified - just load the scripts from env vars
export function loadForteForCurrentEnv() {
  console.log('[ForteScriptLoader] Loading Forte scripts from environment configuration');
  return loadForteScripts();
}
